export default __webpack_public_path__ + "static/media/notification.53bc4b2e.mp3";